import React, { useEffect } from 'react'
import './stats.css'

export default function Stats() {
    useEffect(()=> {
        let valueDisplays = document.querySelectorAll(".number");
        let interval = 4000;

        valueDisplays.forEach((valueDisplay) => {
            let startValue = 0;
            let endValue = parseInt(valueDisplay.getAttribute("data-goal"));
            let duration = Math.floor(interval / endValue);
            let counter = setInterval(function () {
                startValue += 1;
                valueDisplay.textContent = startValue;
                if (startValue == endValue) {
                clearInterval(counter);
                }
            }, duration);
        });
    }, [])
    return(
        <div>
            {/* <!-- Start Stats --> */}
            <div className="stats" id="stats">
            <h1 className='main-title'>Our Stats</h1>
            <div className="container" style={{color:'#000'}}>
                <div className="box">
                    <i className="far fa-user fa-2x fa-fw"></i>
                    <span className="number" data-goal="70">0</span>
                    <span className="text">Members</span>
                </div>
                <div className="box">
                    <i className="fas fa-code fa-2x fa-fw"></i>
                    <span className="number" data-goal="10">0</span>
                    <span className="text">Events</span>
                </div>
                <div className="box">
                    <i className="fas fa-globe-asia fa-2x fa-fw"></i>
                    <span className="number" data-goal="15">0</span>
                    <span className="text">Meets</span>
                </div>
                <div className="box">
                    <i className="far fa-money-bill-alt fa-2x fa-fw"></i>
                    <span className="number" data-goal="1">0</span>
                    <span className="text">Team</span>
                </div>
            </div>
            </div>
            {/* <!-- End Stats --> */}
        </div>
    )
}